import DashboardComp from "../../components/DashboardComp";

const Dashboard: React.FC = () => {
  return <DashboardComp />;
};

export default Dashboard;
